import { Vector3 } from "three";
import { DataTypes } from "./Library/DataTypes";
import { DataType } from "../../evaluators/DataType";

export class StringifierOptions
{
  roundNumbers:boolean = true;
  roundingDigits:number = 4;
  removeZeros:boolean = true;

  processNumber( num:number )
  {
    if ( this.roundNumbers )
    {
      let fixedNumber = num.toFixed( this.roundingDigits );

      if ( this.removeZeros )
      {
        fixedNumber = fixedNumber.replace( /0+$/, "" );
        fixedNumber = fixedNumber.replace( /\.$/, "" );
      }

      return fixedNumber;
    }

    return num + "";
  }

  static createWithRounding( digits:number )
  {
    let options = new StringifierOptions();
    options.roundingDigits = digits;
    return options;
  }
}

export class Stringifier
{
  static stringify( data:any, type:DataType, options:StringifierOptions = null ):string
  {
    options = options || ( new StringifierOptions() );

    if ( data === undefined )
    {
      return "undefined";
    }

    if ( data === null )
    {
      return "null";
    }

    if ( DataTypes.Number === type )
    {
      let value = data as number;
      return options.processNumber( value );
    }
    else if ( DataTypes.Vector3 === type )
    {
      let value = data as Vector3;

      let x = options.processNumber( value.x );
      let y = options.processNumber( value.y );
      let z = options.processNumber( value.z );

      return `Vector3( ${x}, ${y}, ${z} )`;
    }

    return "Unknown Type";
  }
}